export default {"src":"/_next/static/image/public/images/IC_FEMALE_GREEN.fec7a08681eca797d9e2875188c9d8ec.svg","height":20,"width":14};